/*
 * @Author: zhangshengwei
 */
/*
 * @Author: zhangshengwei
 */
/*
 * @Author: zhangshengwei
 */
/*
 * @Author: zhangshengwei
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import * as echarts from "echarts";
import "echarts";
import "./assets/css/common.scss";
import "animate.css";
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/css/common.scss";
import PanelManager from "@common/panel/index";
import tagCloud from "v-tag-cloud";
import "yuki-createjs";
import directive from "./directive"; // directive
import {
  parseTime,
  resetForm,
  addDateRange,
  selectDictLabel,
  selectDictLabels,
  handleTree,
} from "@/utils/ruoyi";
import SeamlessScroll from "@/components/SeamlessScroll";
import { authFile } from "@/utils/index";
// 文件鉴权处理全局方法
Vue.prototype.$authFile = authFile;
import utils from "@/utils";
Vue.use(tagCloud);
Vue.use(directive);
import VueVideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
window.videojs = VueVideoPlayer.videojs;
require("video.js/dist/lang/zh-CN.js");
Vue.use(VueVideoPlayer);
// 过滤
import * as filters from "./filters"; // global filters
// register global utility filters
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});
// vue 滚动插件
import vueSeamlessScroll from "vue-seamless-scroll";
Vue.use(PanelManager);
Vue.use(vueSeamlessScroll);
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;
import axios from "axios";
Vue.prototype.$ajax = axios;
Vue.prototype.$utils = utils;
Vue.prototype.parseTime = parseTime;
Vue.component("SeamlessScroll", SeamlessScroll);
Vue.use(Element);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
